module.exports = __webpack_public_path__ + "img/DE05669.aebca012.png";